import en from './en-US'
import de from './de-DE'
import km from './km-KM'

export default {
  ...en,
  ...de,
  ...km
}
